<template>
  <BreadCrumb PageTitle="Historique des tâches" />
  <UserHistory :userId="userId" />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import UserHistory from "../../components/Users/UsersList/UserHistory.vue";
import { useRoute } from "vue-router";

export default defineComponent({
  name: "UserHistoryPage",
  components: {
    BreadCrumb,
    UserHistory,
  },

   setup: () => {
    const route = useRoute();
    let userId = route.params.id;  // <-- get the id
    if (Array.isArray(userId)) {
      userId = userId[0] ?? "";
    }


    return { userId };
  }
});
</script>